import {createSimpleAction, createTypeAction} from "../utils/actionUtils";

export const SET_FINALIZER_DATA = 'SET_FINALIZER_DATA'
export const setFinalizerData = createSimpleAction(SET_FINALIZER_DATA, 'finalizerData')

export const SAVE_FINALIZER_TERMIN = 'SAVE_FINALIZER_TERMIN'
export const saveFinalizerTermin = createSimpleAction(SAVE_FINALIZER_TERMIN, 'finalizerData')

export const CLEAR_FINALIZER_DATA = 'CLEAR_FINALIZER_DATA'
export const clearFinalizerData = createTypeAction(CLEAR_FINALIZER_DATA)